import React, { Component } from 'react'
import Loading from '../loading/Loading'
import LoadableVisibility from 'react-loadable-visibility/react-loadable'
import './hamburgers.css'
import './hamburgers-custom.css'

import {
  Link,
  NavLink
} from 'react-router-dom'

const LoadableVisibilityProfileImage = LoadableVisibility(
  {loader: () => import('../profile-image/ProfileImage'), loading: Loading})

class Nav extends Component {

  state = {
    navbarCollapsedShown: false
  }

  setNavCollapse = (navCollapseShown: boolean) => {
    this.setState({
      navbarCollapsedShown: navCollapseShown
    })
  }

  toggleNavCollapse = () => {
    this.setNavCollapse(!this.state.navbarCollapsedShown)
  }

  hideNavCollapse = () => {
    this.setNavCollapse(false)
  }

  render () {
    return (
      <nav className='navbar navbar-expand-lg navbar-dark bg-primary fixed-top' id='sideNav'>
        <Link className='navbar-brand' to='/'>
          <span className='d-block d-lg-none'>Harry Jubb</span>
          <span className='d-none d-lg-block'>
            <LoadableVisibilityProfileImage />
          </span>
        </Link>
        <button className={`hamburger hamburger--collapse d-lg-none ${this.state.navbarCollapsedShown ? 'is-active': ''}`} type='button' onClick={this.toggleNavCollapse} data-toggle='collapse' data-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded={this.state.navbarCollapsedShown ? 'true' : 'false'} aria-label='Toggle navigation'>
          <span className='hamburger-box'>
            <span className='hamburger-inner' />
          </span>
        </button>

        <div className={`collapse navbar-collapse ${this.state.navbarCollapsedShown ? 'show': ''}`} onClick={this.hideNavCollapse} id='navbarSupportedContent'>
          <ul className='navbar-nav'>
            <li className='nav-item'>
              <NavLink exact className='nav-link' activeClassName='active' to='/'>Home</NavLink>
            </li>
            {/*
            <li className='nav-item'>
              <NavLink className='nav-link' activeClassName='active' to='/experience'>Experience</NavLink>
            </li>
            <li className='nav-item'>
              <NavLink className='nav-link' activeClassName='active' to='/education'>Education</NavLink>
            </li>
            <li className='nav-item'>
              <NavLink className='nav-link' activeClassName='active' to='/skills'>Skills</NavLink>
            </li>
            <li className='nav-item'>
              <NavLink className='nav-link' activeClassName='active' to='/portfolio'>Portfolio</NavLink>
            </li>
            */}
            <li className='nav-item'>
              <NavLink className='nav-link' activeClassName='active' to='/publications'>Publications</NavLink>
            </li>
            {/*
            <li className='nav-item'>
              <NavLink className='nav-link' activeClassName='active' to='/contact'>Contact</NavLink>
            </li>
            */}
          </ul>
        </div>
      </nav>
    )
  }
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/nav/Nav.js